import type { FooterData } from './Footer';

export const footer_links: Pick<FooterData, 'out_links' | 'sns'> = {
  out_links: {
    marpple_corporation: 'https://www.marpplecorp.com/',
    creator: '/@/hello_creator',
    plus: '/@/plus',
    popup_store: '/@/popup-store',
    offline_popup_store: '/@/popupstore/offline',
    online_popup_store: '/@/popupstore/online',
    brand_commerce: '/@/brand_commerce',
    marppleshop_x_youtube: '/@/youtube',
    handmade_creator: '/@/handmade',
    commerce_creator: '/@/commerce_creator',
    goods_partner: '/@/goodspartner',

    customer_center: '/@/help?type=creator_mall_customer_faq_kr&hg_id=339',
    report_center: '/@/solution',
    terms: '/@/terms',
    privacy: '/@/privacy',
    specific_commerce_laws: '/@/specific_commerce_laws',
    // charge_terms: '/@/terms_paid_service',
  },
  sns: {
    youtube: 'https://www.youtube.com/channel/UCdQ9srG8eu28fSK3BHOKXgA',
    instagram: 'https://www.instagram.com/marpple.shop/',
    twitter: 'https://x.com/marpple_life',
    naver_blog: 'https://blog.naver.com/marpple',
    tiktok: undefined,
  },
};
